import { ValidEmail } from "@dev/ee-api/ee-api-models";

export const isEmailVerified = (email: ValidEmail): boolean => !!email.Validated;
